<template>
	<div class="afizo2-wrapper">
		<input
			type="text"
			class="afizo2"
			:class="[size, status]"
			:value="value"
			:placeholder="placeholder"
			@focus="$emit('focus')"
			@blur="$emit('blur')"
			@input="$emit('input', $event.target.value)"
		/>
		<div class="ico">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				class="ico__svg"
			>
				<path
					d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
				/>
				<path d="M0 0h24v24H0z" fill="none" />
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return val === null || ["error", "success", "warning"].includes(val)
			}
		},
		placeholder: {
			type: String,
			required: false
		}
	}
}
</script>

<style src="./index.css" scoped />
